define([
	"dojo/_base/declare",
	"csi/heading/Property",
	"csi/types"
], function(declare, Property, types) {

	return declare(Property, {
		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: format property value as time
			return types.formatTime(value, fmt || types.FORMAT_DATETIME);
		},

		getDateRangeParams: function(/*Spec*/spec, /*Object?*/extraParams) {
			// summary: return parameters to use for selecting date range
			var h = spec.heading;
			var params = extraParams ? _.clone(extraParams) : {};
			var popupParams = params.popupParams = params.popupParams || {};

			popupParams.allowTime = true;
			popupParams.inPast = true;

			if (h && !h.m_path && (popupParams.allowBlanks == null)) {
				popupParams.allowBlanks = false;
			}

			return params;
		},

		_getCSS: function(/*String*/type, /*String?*/format) {
			// summary: use number CSS
			return "attrNumber attrTime";
		},
	});
});